export default __webpack_public_path__ + "static/media/sortdown.95a63c96.svg";